export const StatCard = ({ icon: Icon, value, label, color = "text-white" }) => (
  <div className="stat-card" data-testid="stat-card">
    <div className="flex items-center gap-4">
      <div className={`p-3 rounded-xl bg-opacity-20 ${color === 'text-lojack-red' ? 'bg-red-500' : 'bg-gray-700'}`}>
        <Icon className={`w-6 h-6 ${color}`} />
      </div>
      <div>
        <div className={`stat-value ${color}`}>{value}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  </div>
);
